<template>
  <div class="wrap-spin">
    <div
      :style="styles"
      class="spinner spinner--square-grid"
    >
      <div
        :style="cubeStyles"
        class="sk-cube sk-cube1"
      />
      <div
        :style="cubeStyles"
        class="sk-cube sk-cube2"
      />
      <div
        :style="cubeStyles"
        class="sk-cube sk-cube3"
      />
      <div
        :style="cubeStyles"
        class="sk-cube sk-cube4"
      />
      <div
        :style="cubeStyles"
        class="sk-cube sk-cube5"
      />
      <div
        :style="cubeStyles"
        class="sk-cube sk-cube6"
      />
      <div
        :style="cubeStyles"
        class="sk-cube sk-cube7"
      />
      <div
        :style="cubeStyles"
        class="sk-cube sk-cube8"
      />
      <div
        :style="cubeStyles"
        class="sk-cube sk-cube9"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    size: {
      type: String,
      default: '40px',
    },
    background: {
      type: String,
      default: '',
    },
    duration: {
      type: String,
      default: '1.3s',
    },
  },
  computed: {
    ...mapGetters({
      isNewDesign: 'featureFlags/isNewDesign',
    }),
    backgroundColor() {
      if (this.background) {
        return this.background;
      }
      return 'var(--color-accent)';
    },
    cubeStyles() {
      return {
        backgroundColor: this.backgroundColor,
        animationDuration: this.duration,
      };
    },
    styles() {
      return {
        width: this.size,
        height: this.size,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap-spin {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.spinner {
  display: inline-block;
}

.spinner * {
  line-height: 0;
  box-sizing: border-box;
}

.sk-cube {
  width: 33%;
  height: 33%;
  // background-color: var(--color-accent);
  float: left;
  animation: sk-cubeGridScaleDelay 1.3s infinite ease-in-out;
}

.sk-cube1 {
  animation-delay: 0.2s;
}

.sk-cube2 {
  animation-delay: 0.3s;
}

.sk-cube3 {
  animation-delay: 0.4s;
}

.sk-cube4 {
  animation-delay: 0.1s;
}

.sk-cube5 {
  animation-delay: 0.2s;
}

.sk-cube6 {
  animation-delay: 0.3s;
}

.sk-cube7 {
  animation-delay: 0s;
}

.sk-cube8 {
  animation-delay: 0.1s;
}

.sk-cube9 {
  animation-delay: 0.2s;
}

@keyframes sk-cubeGridScaleDelay {
  0%,
  70%,
  100% {
    transform: scale3D(1, 1, 1);
  }

  35% {
    transform: scale3D(0, 0, 1);
  }
}
</style>
